// extracted by mini-css-extract-plugin
export default {"image":"PopupPicture_image__VGSCd","coverImage":"PopupPicture_coverImage__d+4RV"};